import { render, staticRenderFns } from "./Notified.vue?vue&type=template&id=3738a8ca&scoped=true"
import script from "./Notified.vue?vue&type=script&lang=js"
export * from "./Notified.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3738a8ca",
  null
  
)

export default component.exports